exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.medical .title[data-v-fe398cd8] {\n  background: url(https://static.soyoung.com/sy-pre/bg-1592287800720.png) no-repeat center center;\n  background-size: contain;\n}\n.medical .iconNumber[data-v-fe398cd8] {\n  width: 0.75rem;\n  height: 0.75rem;\n  border-radius: 50%;\n  background: #00ab84;\n  color: white;\n  margin-right: 0.25rem;\n  display: block;\n  float: left;\n}\n.green[data-v-fe398cd8] {\n  color: #00ab84;\n}\n.margin7-bottom[data-v-fe398cd8] {\n  margin-bottom: 0.35rem;\n}", ""]);

// exports
